/**
 * Thin fetch wrapper for Organization Chart data.
 * Primary: UserService.getAllUsers() → GET /api/user
 * Warm cache: localStorage.allusers (login / users/all)
 */

import UserService from '@/services/user-service'

function extractUserArray(res) {
  if (!res) return []
  if (Array.isArray(res)) return res
  if (res.status === 'OK' && Array.isArray(res.data)) return res.data
  if (Array.isArray(res.data)) return res.data
  if (res.data && Array.isArray(res.data.data)) return res.data.data
  return []
}

function readCachedUsers() {
  try {
    const raw = localStorage.getItem('allusers')
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}

/**
 * Load company users for org chart.
 * Returns cached list immediately-friendly via `{ users, fromCache }`,
 * then caller may refresh — this method awaits API and falls back to cache.
 */
export async function fetchOrgChartUsers() {
  const cached = readCachedUsers()

  try {
    const res = await UserService.getAllUsers()
    const users = extractUserArray(res)
    if (users.length) {
      return { users, fromCache: false }
    }
  } catch (err) {
    console.warn('[org-chart] getAllUsers failed, trying cache / users/all', err)
  }

  if (cached.length) {
    return { users: cached, fromCache: true }
  }

  try {
    const res = await UserService.getAllUsersDdActiveInactive()
    const users = extractUserArray(res)
    if (users.length) {
      try {
        localStorage.setItem('allusers', JSON.stringify(users))
      } catch (e) {
        /* ignore quota */
      }
      return { users, fromCache: false }
    }
  } catch (err) {
    console.warn('[org-chart] getAllUsersDdActiveInactive failed', err)
  }

  return { users: [], fromCache: false }
}

